import { Component, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { type ActiveDialogRef, DialogService } from '../dialog.service';
import { Button } from '@tvd/ui/button';

@Component({
  selector: 'tvd-confirm',
  imports: [Button],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <div class=" text-primary-text" data-testid="confirm-dialog">
      <h2 class="mb-4 text-lg font-semibold">{{ title() }}</h2>
      <p class="mb-4" [innerHtml]="text()"></p>
      <div class="flex flex-col-reverse gap-2 md:flex-row md:justify-end">
        @if (rejectButtonText()) {
          <button
            zynButton
            data-testid="secondary-button"
            (click)="onClose(false)"
            kind="transparent"
            [label]="rejectButtonText()"
          ></button>
        }
        @if (confirmButtonText()) {
          <button
            zynButton
            kind="primary"
            data-testid="primary-button"
            (click)="onClose(true)"
            [label]="confirmButtonText()"
          ></button>
        }
      </div>
    </div>
  `,
})
export class ConfirmComponent implements ActiveDialogRef<boolean> {
  readonly title = input.required<string>();
  readonly text = input.required<string>();
  readonly confirmButtonText = input.required<string>();
  readonly rejectButtonText = input<string | null>(null);

  readonly #dialog = inject(DialogService).active;

  onClose(result?: boolean | undefined) {
    this.#dialog?.close(result);
  }
}
